import { t } from "copy/t";
import Logo from "components/Logo";

/**
 * The gallery's first load failed and no channel data came back: a 404 (the
 * link is wrong or the gallery is gone) or a network/server failure. The page
 * keeps its footer, so the Privacy and Terms links stay below this message.
 * No channel colour is known, so it sets white on the page's default black.
 */
const GalleryLoadError = ({ notFound, onRetry }) => (
  <div className="flex flex-col items-center px-6 pt-24 pb-12 w-full">
    <div className="flex flex-col gap-3 items-center text-center w-full max-w-[420px] text-white">
      {/* The Movebooth mark, as on a gate with no channel logo: no channel
          data came back, so there is no channel logo to show. */}
      <div className="mb-5">
        <Logo withText={true} fill="white" />
      </div>
      <h1 className="font-headline text-3xl font-bold leading-tight text-balance">
        {t(notFound ? "galleryLoadError.notFoundTitle" : "galleryLoadError.title")}
      </h1>
      <p className="font-inter font-normal text-base leading-relaxed text-white/80 text-balance">
        {t(notFound ? "galleryLoadError.notFoundBody" : "galleryLoadError.body")}
      </p>
      {notFound ? null : (
        <button
          type="button"
          onClick={onRetry}
          className="mt-5 inline-flex items-center justify-center min-h-[48px] px-6 py-3 rounded-lg bg-white text-black font-headline text-base font-bold leading-tight transition-transform duration-200 [transition-timing-function:var(--ease-out)] hover:outline hover:outline-1 hover:outline-offset-2 hover:outline-white active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
        >
          {t("galleryLoadError.retry")}
        </button>
      )}
    </div>
  </div>
);

export default GalleryLoadError;
